import React from 'react';
import { Link, graphql } from 'gatsby';
import Img from 'gatsby-image';
import '../assets/css/main.css'
// import playbutton from '../assets/images/playbutton.png'


class Welcome extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      fixed: false
    };
  }
  
  render() {     
    var image = this.props.image  
    
    return (
      <React.Fragment>
        <div style={{marginTop:'5vmin'}}>          
          <div className="welcome_container">
            {/* <div className="welcomeImage">            
              <img src={halfpuck} />
            </div>                       */}
            <div className="welcomeText">
              <h1>AquaFlow Plumbing, Drainage &amp; Gas Fitting</h1>
              <h3>Reliable and Professional Plumbing Services</h3>
              <p>Aquaflow QLD offer a diverse range of expert and reliable plumbing and gas fitting services to Dysart and surrounding areas. We take pride in our professional approach to customers and aim to provide a service above all expectation. </p>
              <p>We have been part of the community for over 10yrs and are committed to ensuring there is always a top-quality plumbing service available whenever you need it.</p>
            </div>            
          </div>
        </div>
      </React.Fragment>
    );
  }
}


export default Welcome
